import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { reducer } from "./slices/user";
import { notificationReducer } from "./slices/notification";
import { sellerMenuReducer } from "./slices/sellerMenu";
import { buyerMenuReducer } from "./slices/buyerMenu";
import { sellerAssetReducer } from "./slices/sellerAssetSlice";
import { buyerAssetReducer } from "./slices/buyerAssetSlice";
import { sellerSubscriptionReducer } from "./slices/sellerSubscriptionSlice"; // Claude: renamed 08-Apr-2026
import { buyerSubscriptionReducer } from "./slices/buyerSubscriptionSlice"; // Claude: buyer subscription plans 11-Apr-2026
import { aiChatReducer } from "./slices/aiChatSlice"; // Claude: unified AI chat history 23-03-2026






import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web


const persistConfig = {
  key: 'root',
  storage,
}

const reducers = combineReducers({
  user: reducer,
  notification: notificationReducer,
  sellerMenu: sellerMenuReducer,
  buyerMenu: buyerMenuReducer,
  sellerAsset: sellerAssetReducer,
  buyerAsset: buyerAssetReducer,
  sellerSubscription: sellerSubscriptionReducer,
  buyerSubscription: buyerSubscriptionReducer, // Claude: buyer subscription plans 11-Apr-2026
  aiChat: aiChatReducer, // Claude: unified AI chat history 23-03-2026
});

const persistedReducer = persistReducer(persistConfig, reducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});


export const persistor = persistStore(store);